import React from 'react';
import { Box } from '@mui/material';

// Companion to BulletList — for the occasional section (like Data Retention
// Policy's "Principles") where the source document deliberately numbers
// items rather than bulleting them. Uses a real <ol> for correct semantic
// numbering rather than faking numbers as text inside a bulleted list.
const NumberedList = ({ items }) => (
  <Box component="ol" sx={{ pl: 3, py: 0, m: 0 }}>
    {items.map((item, index) => (
      <Box component="li" key={index} sx={{ py: 0.5 }}>
        {item}
      </Box>
    ))}
  </Box>
);

export default NumberedList;
